export function stripHtml(html) {
  if (!html || typeof html !== 'string') return '';
  if (typeof DOMParser === 'undefined') {
    return html.replace(/<[^>]+>/g, '').trim();
  }
  return new DOMParser().parseFromString(html, 'text/html').body.textContent?.trim() ?? '';
}
